import BlockIcon from "@mui/icons-material/Block.js";
import { Typography, Button, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ADD_BUTTON_COLUMN_WIDTH, COLUMN_MARGIN } from "../../appointment-schedule.constants.js";
import { AddIcon } from "../../assets/icons/Add.js";
import "react/jsx-runtime";
const FreeSlotsGroupWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "top" && props !== "height" && props !== "isPast" && props !== "isOverbooked"
})(
  ({ theme, top, height, isPast, isOverbooked }) => `
  position: absolute;
  top: ${top ?? 0}%;
  left: 0;
  height: ${height ?? 0}%;
  background: transparent;
  color: ${theme.palette.grey[700]};
  width: ${isOverbooked ? "100%" : `calc(100% + ${ADD_BUTTON_COLUMN_WIDTH}px)`};
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 3;
  opacity: ${isPast ? 0.7 : 1};
`
);
const DetailsWrapper = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 4px;
`;
const StyledTypography = styled(Typography)(({ theme }) => ({
  whiteSpace: "nowrap",
  color: theme.palette.grey[800]
}));
const StyledSlot = styled(Button, {
  shouldForwardProp: (props) => props !== "height" && props !== "disabled" && props !== "isOverbooked" && props !== "isActive"
})(
  ({ theme, height, disabled, isOverbooked, isActive }) => `
  && {
    height: ${height}px;
    padding: ${isOverbooked ? 0 : COLUMN_MARGIN}px;
    margin: 0;
    border-radius: ${isOverbooked ? "0" : "4px"};
    background: ${theme.palette.success[50]};
    color: ${theme.palette.grey[700]};
    width: 100%;
    text-align: left;
    justify-content: flex-start;
    opacity: ${isActive ? 1 : 0};
    z-index: 1;
    display: flex;
    box-shadow: 0px 0.5px 1px 0px rgba(0, 0, 0, 0.35), 0px -0.5px 0.5px 0px rgba(0, 0, 0, 0.1);
    cursor: ${disabled ? "default" : "pointer"};
    min-width: 100%;

    &:hover {
      opacity: ${disabled ? 0 : 1};
    }
  }
`
);
const StyledAddIcon = styled(AddIcon, {
  shouldForwardProp: (props) => props !== "isOverbooked"
})(
  ({ theme, isOverbooked }) => `
  &&& {
    width: 12px;
    height: 12px;
    color: ${theme.palette.primary[800]};
    margin-right: ${isOverbooked ? 0 : COLUMN_MARGIN}px;
    width: ${isOverbooked ? ADD_BUTTON_COLUMN_WIDTH - COLUMN_MARGIN : ADD_BUTTON_COLUMN_WIDTH}px;
    height: ${isOverbooked ? ADD_BUTTON_COLUMN_WIDTH - COLUMN_MARGIN : ADD_BUTTON_COLUMN_WIDTH}px;
  }
`
);
const StyledAddBlockerButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 0,
  top: 0,
  bottom: 0,
  padding: theme.spacing(1),
  backgroundColor: "transparent",
  borderRadius: "4px",
  minWidth: "unset",
  height: "unset",
  boxShadow: "unset",
  "&:hover": {
    backgroundColor: theme.palette.success[100],
    boxShadow: "-0.5px 0.5px 1px 0px rgba(0, 0, 0, 0.35), 0px -0.5px 0.5px 0px rgba(0, 0, 0, 0.1)"
  }
}));
const StyledBlockIcon = styled(BlockIcon)(({ theme }) => ({
  "&&&": {
    width: "12px",
    height: "12px",
    backgroundColor: theme.palette.secondary[500],
    color: theme.palette.common.white,
    borderRadius: "50%",
    transform: "rotate(90deg)"
  }
}));
export {
  DetailsWrapper,
  FreeSlotsGroupWrapper,
  StyledAddBlockerButton,
  StyledAddIcon,
  StyledBlockIcon,
  StyledSlot,
  StyledTypography
};
